import { render, staticRenderFns } from "./PredictiveView.vue?vue&type=template&id=04f37eda&scoped=true"
import script from "./PredictiveView.vue?vue&type=script&lang=js"
export * from "./PredictiveView.vue?vue&type=script&lang=js"
import style0 from "./PredictiveView.vue?vue&type=style&index=0&id=04f37eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f37eda",
  null
  
)

export default component.exports